import type { AnalyticsOptions } from '@bootstrap/types'
import { analytics } from '@shared/analytics/analytics'

import { trackError } from '@fond-of/telemetry'

export const bootstrapAnalyticsClient = async ({
  google = {},
}: AnalyticsOptions = {}) => {
  try {
    analytics.microsoftAdvertising.init()

    analytics.google.init({
      ...google,
      gtmId: import.meta.env.PUBLIC_GOOGLE_TAG_MANAGER_ID,
      usercentricsId: import.meta.env.PUBLIC_USERCENTRICS_ID,
    })
  } catch (error) {
    trackError(error)
  }
}
